import { createSelector } from 'reselect'
import { selectCurrentAgent } from 'selectors/agents/base'
import { selectPreferences } from 'ducks/currentUser/selectors'

const ANY_GROUP = null

export const selectPreferredReassignment = createSelector(
  selectCurrentAgent,
  currentAgent => {
    return { assignee: currentAgent, assigned_group_id: ANY_GROUP }
  }
)

export const selectDefaultNote = createSelector(
  selectPreferences,
  selectPreferredReassignment,
  (preferences, reassignment) => {
    const defaultNote = { body: null }

    if (preferences.reassign_ticket_on_note) {
      Object.assign(defaultNote, reassignment)
    }

    return defaultNote
  }
)
